import axios from 'axios'
import LeafletWMS from 'leaflet.wms'
import { lib } from '@giscube/geoportal'
const L = lib.L

import { jsonFileToObject, gmlFileToObject } from './fileUtils.js'

export async function createLayer ({ format, url, projection, style, wmsLayers, wmsSingleImage, tmsInvert }) {
  if (format === 'WMS') {
    return createWMSLayer(url, wmsLayers, wmsSingleImage)
  } else if (format === 'TMS') {
    return createTMSLayer(url, tmsInvert)
  } else if (format === 'GeoJSON') {
    return createGeoJSONLayer(url, style)
  } else if (format === 'GML') {
    return createGMLayer(url, style)
  }
}

function createWMSLayer (url, wmsLayers, wmsSingleImage) {
  const layers = wmsLayers.replaceAll(', ', ',')
  const options = {
    layers,
    format: 'image/png',
    transparent: true
  }
  if (wmsSingleImage) {
    return LeafletWMS.overlay(url, options)
  } else {
    return L.tileLayer.wms(url, options)
  }
}

function createTMSLayer (url, tmsInvert) {
  return L.tileLayer(url, { tms: tmsInvert })
}

async function createGeoJSONLayer (url, style) {
  const data = await getGeoJSONdata(url)
  return L.geoJSON(data, {
    style,
    onEachFeature: function (feature, layer) {
      let popup = ''
      for (let prop in feature.properties) {
        popup += '<div>' + prop.toUpperCase() + ': ' + feature.properties[prop] + '</div>'
      }
      layer.bindPopup(popup)
    }
  })
}

async function createGMLayer (url, style) {
  const data = await getGMLdata(url)
  return L.geoJSON(data, {
    style,
    onEachFeature: function (feature, layer) {
      let popup = ''
      for (let prop in feature.properties) {
        popup += '<div>' + prop.toUpperCase() + ': ' + feature.properties[prop] + '</div>'
      }
      layer.bindPopup(popup)
    }
  })
}

async function getGeoJSONdata ({ type, value }) {
  if (type === 'file') {
    return jsonFileToObject(value)
  } else if (type === 'string') {
    axios.defaults.headers = {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
    const response = await axios.get(value)
    return response.data
  }
}

async function getGMLdata ({ type, value }) {
  if (type === 'file') {
    return gmlFileToObject(value)
  } else if (type === 'string') {
    axios.defaults.headers = {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
    const response = await axios.get(value)
    return response.data
  }
}
